/* eslint-disable */
import { Box, Typography, MenuItem, Menu } from '@mui/material';
import { useState } from 'react';
import DateRangeEditor from '../../../../Components/CustomDateRange/dateRangeInput';
import ButtonComponent from '../../../../Components/Button/button';
import ArrowDropDown from '../../../../Assets/images/svg/drop-down-arrow.svg';
import './reportFiltersBar.scss';
import expandAllIcon from '../../../../Assets/images/svg/dar_collection_dashboard_expand_all.svg';
import collapseAllIcon from '../../../../Assets/images/svg/dar_collection_dashboard_collapse_all.svg';
import { IconButton, Tooltip } from '@mui/material';
import { getOverallReportExcel } from '../../../../Api/request/reports';
import UseAxios from '../../../../Api/http/http';
import MultiSelectSearchDropdown from '../../../../Components/MultiFilterSearch/multiFilterSearch';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';
import { STAFF_AUGMENTATION } from '../../../../Constants/strings';
import excelIcon from '../../../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../../../Assets/images/svg/excel_hover.svg';
import pdfIcon from '../../../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../../../Assets/images/svg/pdf_hover.svg';
import dayjs from 'dayjs'; 

const ReportFiltersBar = ({
  dateRangeKey,
  dateRange,
  handleDateRangeChange,
  dealType,
  setDealType,
  handleClearFilters,
  definedRanges,
  allExpanded,
  expandAllHandler,
  fetchReportData,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElFormat, setAnchorElFormat] = useState(null);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const [isPdfHovered, setIsPdfHovered] = useState(false);

  const [selectedDownloads, setSelectedDownloads] = useState([]);
  const { snackbarOpen } = useSnackbar();

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedDownloads([]);
  };

  const DOWNLOAD_OPTIONS = [
    { value: 'all', label: 'Select All' },
    { value: 'oor', label: 'Opportunity Overview' },
    { value: 'ldr', label: 'Lost/Dropped Report' },
    { value: 'ppr', label: 'Pending Positions' },
    { value: 'ctw', label: 'Closure This Week' },
    { value: 'dmr', label: 'Delivery Manager Wise Data' },
    { value: 'smr', label: 'Sales Member Wise Data' },
    { value: 'rpo', label: 'Resource Pending Onboarding' },
  ];

  const DEAL_TYPE_OPTIONS = [
    { name: 'Global', value: 'global' },
    { name: 'Domestic', value: 'domestic' },
  ];

  const allItems = DOWNLOAD_OPTIONS.filter((opt) => opt.value !== 'all').map(
    (opt) => opt.value
  );
  const isAllSelected = allItems.every((item) =>
    selectedDownloads.includes(item)
  );
  const handleToggleDownloadOption = (value) => {
    if (value === 'all') {
      setSelectedDownloads(isAllSelected ? [] : allItems);
    } else {
      setSelectedDownloads((prev) =>
        prev.includes(value)
          ? prev.filter((v) => v !== value)
          : [...prev, value]
      );
    }
  };

  const handleResetDownloads = () => {
    setSelectedDownloads([]);
  };

  const formatDate = (date) => {
    if (!date) return '';
    return dayjs(date).format('YYYY-MM-DD'); // Format date using Day.js
  };
  
  const handleDownloadExcel = async (currentDateRange) => {
    handleCloseMenu();
  
    const { startDate, endDate } = currentDateRange;
  
    if (!startDate || !endDate) {
      snackbarOpen('Please select start date and end date', 'warning');
      return;
    }
  
    const payload = {
      dealType,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      shortNameofReports: selectedDownloads,
      format: 'excel',
    };
    
    try {
      const response = await UseAxios(getOverallReportExcel(payload));
    } catch (error) {
      console.error('Download failed', error);
    }
  };

  const handleChooseFormat = (event) => {
    setAnchorElFormat(event.currentTarget);
  };

  const handleCloseFormat = () => {
    setAnchorElFormat(null);
  };
  const handleDownloadPdf = async () => {
    handleCloseMenu();
    if (!dateRange?.startDate || !dateRange?.endDate) {
      snackbarOpen('Please select start date and end date', 'warning');
      return;
    }
    
    const payload = {
      dealType,
      startDate: formatDate(dateRange.startDate),
      endDate: formatDate(dateRange.endDate),
      shortNameofReports: selectedDownloads,
      format: 'pdf',
    };
    try {
      const response = await UseAxios(getOverallReportExcel(payload));
    } catch (error) {
      console.error('Download failed', error);
    }
  };
  return (
    <Box className="report-filter-panel">
      <Box className="report-filter-bar">
        <Typography className="report-filter-note">
          <span style={{ color: 'black' }}>Note:</span> Please select date from
          start and end of the week (Monday to Sunday)
        </Typography>

        <Box className="filter-controls">
          <div className="date-range-container">
            <DateRangeEditor
              key={dateRangeKey}
              dateRange={dateRange}
              onChange={(newRange) => {
                handleDateRangeChange(newRange);
              }}
              fromPlaceholder="From Date"
              toPlaceholder="To Date"
              definedRanges={definedRanges}
              dateFormat="dd/mm/yyyy"
              useCurrentYear
              splitInitialCustomMonthView={true}
            />
          </div>
          <MultiSelectSearchDropdown
            dropdownCss="deal-type-dropdown"
            options={DEAL_TYPE_OPTIONS}
            value={
              dealType
                ? DEAL_TYPE_OPTIONS.filter((opt) =>
                    dealType.includes(opt.value)
                  )
                : []
            }
            onChange={(e) => {
              const selectedDealTypes = e.target.value.map((opt) => opt.value);
              setDealType(selectedDealTypes);
              // fetchReportData(selectedDealTypes);
            }}
            placeholder="Select deal type"
            size="small"
            id="deal-type-dropdown"
            SearchPlaceHolder="Select deal type"
            showFilterIcon={false}
            searchBox={false}
            checkboxClassName="deal-type-checkbox"
          />
          <Box className="action-row">
            <ButtonComponent
              label="Clear filter"
              variant="text"
              onClick={handleClearFilters}
              btnCss="clear-filter-btn"
            ></ButtonComponent>
            <ButtonComponent
              label="Download"
              variant="text"
              onClick={handleDownloadClick}
              endIcon={<img alt="Arrow Down" src={ArrowDropDown} />}
              btnCss="download-reports"
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              PaperProps={{
                className: 'download-dropdown-menu',
              }}
            >
              <MenuItem key="all" className="download-dropdown">
                <label>
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={() => handleToggleDownloadOption('all')}
                  />
                  Select All
                </label>
              </MenuItem>

              <Box className="dropdown-separator" />

              {DOWNLOAD_OPTIONS.filter((opt) => opt.value !== 'all').map(
                (option) => (
                  <MenuItem key={option.value} className="download-dropdown">
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedDownloads.includes(option.value)}
                        onChange={() =>
                          handleToggleDownloadOption(option.value)
                        }
                      />
                      {option.label}
                    </label>
                  </MenuItem>
                )
              )}

              <Box className="dropdown-separator" />

              <Box className="dropdown-footer">
                <ButtonComponent
                  label="Download as Excel"
                  variant="text"
                  onClick={() => handleDownloadExcel(dateRange)}
                  btnCss="download-excel-btn"
                  onMouseEnter={() => setIsExcelHovered(true)}
                  onMouseLeave={() => setIsExcelHovered(false)}
                />

                <ButtonComponent
                  label="Download as PDF"
                  variant="text"
                  onClick={handleDownloadPdf}
                  btnCss="download-pdf-btn"
                  onMouseEnter={() => setIsPdfHovered(true)}
                  onMouseLeave={() => setIsPdfHovered(false)}
                />
              </Box>

            </Menu>
            <Tooltip title={allExpanded ? 'Collapse all' : 'Expand all'}>
              <IconButton
                id="expand-collapse-btn"
                onClick={expandAllHandler}
                className="expand-collapse-btn"
              >
                <img
                  src={allExpanded ? collapseAllIcon : expandAllIcon}
                  alt={allExpanded ? 'Collapse all' : 'Expand all'}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReportFiltersBar;
